import { useState, useEffect } from 'react';
import axios from 'axios';

interface Branding {
  appName: string;
  logoUrl: string | null;
}

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://crm.ai-dla-firmy.pl/api';

export const useBranding = () => {
  const [branding, setBranding] = useState<Branding>({
    appName: 'CRM Meeting Notes',
    logoUrl: null,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBranding = async () => {
      try {
        const response = await axios.get<{
          success: boolean;
          branding: Branding;
        }>(`${API_BASE_URL}/branding`);

        if (response.data.success) {
          setBranding(response.data.branding);
        }
      } catch (error) {
        console.error('Failed to fetch branding:', error);
        // Keep default values on error
      } finally {
        setLoading(false);
      }
    };

    fetchBranding();
  }, []);

  return { branding, loading };
};
